export const ReferralStatus = {
  Purchased: {
    className: 'Purchased',
    title: 'Purchased',
    i18nKey: 'dashboard_Purchased',
  },
  AdditionalPurchase: {
    className: 'AdditionalPurchase',
    title: 'Additional Purchase',
    i18nKey: 'dashboard_AdditionalPurchase',
  },
  PendingAdditionalPurchase: {
    className: 'PendingAdditionalPurchase',
    title: 'Pending Additional Purchase',
    i18nKey: 'dashboard_PendingAdditionalPurchase',
  },
  PartiallyPurchased: {
    className: 'PartiallyPurchased',
    title: 'Partially Purchased',
    i18nKey: 'dashboard_PartiallyPurchased',
  },
  Pending: {
    className: 'Pending',
    title: 'Pending',
    i18nKey: 'dashboard_Pending',
  },
};

export const AllReferralStatuses = [
  ReferralStatus.Purchased,
  ReferralStatus.PartiallyPurchased,
  ReferralStatus.AdditionalPurchase,
  ReferralStatus.PendingAdditionalPurchase,
  ReferralStatus.Pending,
];

export const ReferralSource = {
  HVSReco: {
    title: 'HVS Reco',
    i18nKey: 'dashboard_HVSReco',
  },
  HVSSharedCode: {
    title: 'HVS Shared Code',
    i18nKey: 'dashboard_HVSSharedCode',
  },
  QuickReco: {
    title: 'QuickReco',
    i18nKey: 'dashboard_QuickReco',
  }
};

export const AllReferralSources = [
  ReferralSource.HVSReco,
  ReferralSource.HVSSharedCode,
  ReferralSource.QuickReco,
];

export const ReferralSortingOptions = (t) => [
  { value: 'refDetails ASC', label: t('dashboard_PetName') },
  { value: 'consumerName ASC', label: t('dashboard_ParentName') },
  { value: 'createdAt DESC', label: t('dashboard_Date'), default: true },
  { value: 'totalCommissionValue ASC', label: t('dashboard_Earnings') },
  { value: 'status DESC', label: t('dashboard_Status') },
];
